import { Component, h, Host, Prop } from "@stencil/core";

import state from "@stores/impersonate.store";
import FImpersonateFeatureBarModelProps from "./f-impersonate-feature-bar-model";

@Component({
  tag: "f-impersonate-feature-bar",
  styleUrl: "f-impersonate-feature-bar.scss",
  shadow: true,
})
export class FImpersonateFeatureBar {
  private searchField: HTMLFSearchFieldElement;

  @Prop()
  actAsMyselfButtonLabel: FImpersonateFeatureBarModelProps["actAsMyselfButtonLabel"];

  @Prop()
  searchPlaceholder: FImpersonateFeatureBarModelProps["searchPlaceholder"];

  @Prop()
  handleSearchAction: FImpersonateFeatureBarModelProps["handleSearchAction"];

  @Prop()
  handleActAsMyselfButtonPress: FImpersonateFeatureBarModelProps["handleActAsMyselfButtonPress"];

  @Prop()
  showActAsMyselfButton: FImpersonateFeatureBarModelProps["showActAsMyselfButton"] =
    false;

  private handleKeydown = (event: KeyboardEvent): void => {
    if (event.key === "Enter") {
      const searchValue: string = this.searchField.shadowRoot
        .querySelector("f-text-field")
        .shadowRoot.querySelector("input").value;
      this.filterCustomersByPattern(searchValue);
    }
  };

  private onSearchFieldSubmitted = (
    e: CustomEvent<{
      fieldId: string;
      value: string;
      valid: boolean;
    }>
  ): void => {
    this.filterCustomersByPattern(e.detail.value);
  };

  private checkInclusivity(phrase: string, pattern: string): boolean {
    return phrase.toLowerCase().includes(pattern.toLowerCase());
  }

  private filterCustomersByPattern = (pattern: string) => {
    const visibleCustomers = state.customers.filter(
      ({ customerId, customerName, customerAddress }) =>
        this.checkInclusivity(customerId.toString(), pattern) ||
        this.checkInclusivity(customerName.toString(), pattern) ||
        this.checkInclusivity(customerAddress.toString(), pattern)
    );
    this.handleSearchAction(visibleCustomers);
  };

  private onCustomerSearchReset = (): void => {
    this.handleSearchAction(state.customers);
  };

  render() {
    return (
      <Host data-test="impersonate-feature-bar">
        <div class="f-mini-impersonate-flyout__feature-bar">
          {this.showActAsMyselfButton && (
            <div class="flyout-top-button-content">
              <f-button
                variant="secondary"
                fullWidth={true}
                onClick={this.handleActAsMyselfButtonPress}
              >
                {this.actAsMyselfButtonLabel}
              </f-button>
            </div>
          )}
          <f-flyout-feature-bar variant="single">
            <f-search-field
              slot="feature-bar-content"
              ref={(el) => (this.searchField = el)}
              property-id="impersonal-search-field"
              placeholder={this.searchPlaceholder}
              onSearchFieldSubmitted={this.onSearchFieldSubmitted}
              onSearchFieldReset={this.onCustomerSearchReset}
              onKeyDown={this.handleKeydown}
            ></f-search-field>
          </f-flyout-feature-bar>
        </div>
      </Host>
    );
  }
}
